import React from "react"
import { useSelector } from "react-redux"

import { StoreType } from "client/store"
import {
    Container,
    PageContent,
    PageForm,
} from "client/components"

import MainSettings from "./mainSettings"
import CalculationSettings from "./calculationSettings"
import DefaultAccountSettings from "./defaultAccountSettings"

const Sil = () => {
    const userData = useSelector((state: StoreType) => state.system.userData)

    return (
        <Container>
            {
                userData.accountId === 1
                    ? (
                        <PageContent>
                            <PageForm>
                                <DefaultAccountSettings />
                            </PageForm>
                        </PageContent>
                    )
                    : (
                        <PageContent>
                            <MainSettings />
                            <CalculationSettings />
                        </PageContent>
                    )
            }
        </Container>
    )
}
export default Sil
